export class Matchmaking {
    constructor(
        public id: any,
        public create_at: Date,
        public acceptor_id: string,
        public acceptor_name: string,
        public task_id: string,
    ) { }
}
